import React from "react";


export default function(props){
  const path=`/assets/${props.image}.png`
  return(
    <div className="template">
    <div className="card-border">
     <div className="Icon"><img src={path} alt="Icon"/></div>
     <div className="ReasonHeading">{props.heading}</div>
     <div className="ReasonDescription">{props.description}</div>
    </div>
    </div>
  )
}
